/**
 * Invitations API service
 */
import axios from 'axios';
import { InvitationCheckResponse } from '../types/company';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Public invitation endpoints

export const checkInvitationToken = async (
  token: string
): Promise<InvitationCheckResponse> => {
  const response = await axios.get(`${API_URL}/api/v1/invitations/${token}`);
  return response.data;
};

export const acceptInvitation = async (token: string): Promise<{ message: string; company_id: number }> => {
  const response = await axios.post(
    `${API_URL}/api/v1/invitations/${token}/accept`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
  return response.data;
};
